import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  root: {
    border: `1px solid ${foundations.colors.gray300}`,
    borderRadius: '4px',
    backgroundColor: foundations.colors.white,
    overflow: 'clip',
  },
  filterBox: {
    padding: '8px',
    borderBottom: `1px solid ${foundations.colors.gray200}`,
  },
  selectAllRow: {
    borderBottom: `1px solid ${foundations.colors.gray200}`,
    padding: '0 8px',
  },
  treeBox: {
    overflowY: 'auto',
  },
  nodeRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    minHeight: '36px',
    gap: '2px',
    '&:hover': {
      backgroundColor: foundations.colors.gray50,
    },
  },
  nodeRowDisabled: {
    opacity: 0.5,
  },
  nodeRowDisabledLabel: {
    cursor: 'default',
    pointerEvents: 'none',
  },
  expandButton: {
    padding: '2px',
    flexShrink: 0,
  },
  expandPlaceholder: {
    width: '28px',
    flexShrink: 0,
  },
  nodeLabel: {
    fontSize: '14px',
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  nodeLabelDisabled: {
    color: foundations.colors.gray400,
    fontSize: '12px',
    marginLeft: '4px',
    flexShrink: 0,
  },
  toggleIcon: {
    fontSize: '18px',
    color: foundations.colors.gray500,
  },
  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
  },
});
